import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from "../../../../../../shared/button/button.component";

@Component({
  selector: 'app-element-message',
  standalone: true,
  imports: [
    ButtonComponent
  ],
  templateUrl: './element-message.component.html',
  styleUrl: './element-message.component.scss'
})
export class ElementMessageComponent {
  @Input() text: string;
  @Input() active: boolean = false;
  @Input() variant: 'danger' | 'warning' | 'success' | 'info' | 'placeholder' = 'placeholder';

  @Output('removeClick') removeClick = new EventEmitter();
  @Output('editClick') editClick = new EventEmitter();

  showConfirmation: boolean = false;

  get styleClassName() {
    if (this.showConfirmation)
      return 'element-message__confirmation';

    let className = `element-message__${this.variant}`;

    if (!this.active)
      className = `${className} element-message__inactive`;

    return className;
  }

  toggleConfirmation() {
    this.showConfirmation = !this.showConfirmation;

    console.log('set confirmation to ' + this.showConfirmation)
  }

  onCancelRemove() {
    this.showConfirmation = false;
  }

  onConfirmRemove() {
    this.showConfirmation = false;
    this.removeClick.emit();
  }
}
